// removed by extract-text-webpack-plugin
module.exports = {"root":"root_1N5Te","root_input":"root_input_10egH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckboxButtonInput/style.css
// module id = 226
// module chunks = 0